module.exports = __webpack_public_path__ + "static/media/subscribeDiscount0.69ce0b7f.svg";